import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import * as moment from 'moment';
import * as g from 'src/app/globals';
import { LayoutService } from '../layout.service';
import { ModuleInformation } from 'src/app/models/module-information';
import { ModuleStructure } from 'src/app/models/module-structure';
import { RecordCategory, RecordModel } from '../record-model';
import { NzListModule } from 'ng-zorro-antd/list';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { BehaviorSubject, interval, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { filter } from 'rxjs/operators';
import { RecordPageComponent } from '../record-page/record-page.component';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.less']
})
export class CommentComponent implements OnInit {
  activitiesData: any[];
  isLoading = true;
  moduleInformation: ModuleInformation;
  moduleStructure: ModuleStructure;
  urlPrefix = '/apps/crm/module-list';

  constructor(
    private layoutService: LayoutService,
    private router: Router,
    private drawerService: NzDrawerService,
    private msg: NzMessageService
  ) {}
  @Input() moduleId: number;
  @Input() recordId: string | number;
  @Input() recordModel: RecordModel;

  ngOnInit(): void {

    this.activitiesList();

    this.initializeList();

  }

  initializeList() {
    this.layoutService
      .getModuleStructure(this.moduleId)
      .subscribe((m: ModuleStructure) => {
        this.moduleStructure = m;
        this.isLoading = false;
      });

    this.layoutService
      .moduleInformation(this.moduleId.toString())
      .subscribe((d: ModuleInformation) => {
        this.moduleInformation = d;
        // this.name = this.moduleInformation.PluralName;
        this.moduleInformation.ModuleId = this.moduleId;
      });
  }

  activitiesList() {

    interval(3000).subscribe(x =>{
      this.isLoading = true;
      this.layoutService
      .activitiesList(this.recordModel.ObjectCode, this.recordId)
      .subscribe((result: { rows: any[] }) => {
        // tslint:disable-next-line: forin
        const children: any[] = [];
        // tslint:disable-next-line: forin
        for (const key in result.rows) {
          children.push(result.rows[key]);
        }
        let chkGrp: any[] = [];
        children.map((item) => {
          const existItem = chkGrp.find(
            (x) => x.U_ITM_ACT_GUID === item.U_ITM_ACT_GUID
          );
          if (existItem) {
            if (item.AttendEmpl !== ' ' && existItem.AttendEmpl !== '') {
              existItem.AttendEmpl =
                existItem.AttendEmpl + ',' + item.AttendEmpl;
            } else if (item.AttendEmpl !== ' ') {
              existItem.AttendEmpl = item.AttendEmpl;
            }
            if (item.AttendUser !== ' ' && existItem.AttendUser !== '') {
              existItem.AttendUser =
                existItem.AttendUser + ',' + item.AttendUser;
            } else if (item.AttendUser !== ' ') {
              existItem.AttendUser = item.AttendUser;
            }
          } else {
            chkGrp.push(item);
          }
        });
        chkGrp = chkGrp.sort((a, b) => {
          const dataA = new Date(a.Recontact);
          const dataB = new Date(b.Recontact);
          if (dataA > dataB) { return -1; }
          else if (dataA < dataB) { return 1; }
          else { return 0; }
        });
        // chkGrp = chkGrp.sort((a, b) => {
        //   const dataA = a.BeginTime;
        //   const dataB = b.BeginTime;
        //   if (dataA > dataB) { return -1; }
        //   else if (dataA < dataB) { return 1; }
        //   else { return 0; }
        // });
        this.activitiesData = chkGrp;
        console.log('activitiesData', this.activitiesData);
        this.isLoading = false;
      });
    });

  }

  // navigateTo(model, id) {
  //   // this.router.navigate([
  //   //   `${this.urlPrefix}/${model}`,
  //   //   {
  //   //     selectedId: id,
  //   //   },
  //   // ]);
  //   RecordPageComponent.openRecordPage(this.drawerService, {
  //     actionType: this.moduleInformation.AuthorisedForEdit ? 'Edit' : 'View',
  //     drawerTitle: `Activity #${id}`,
  //     inDrawer: true,
  //     moduleId: Number(model),
  //     parentComponent: this,
  //     recordId: id,
  //     recordModel: undefined,
  //   });
  //   console.log(`${this.urlPrefix}/${model};selectedId=${id}`);
  //   /// module-list/54;selectedId=72
  // }

}
